"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var _1 = require("../util/_");
var warning_1 = require("../util/warning");
var vdl_prefix_1 = require("../util/vdl-prefix");
var didWarnValueDefaultValue = false;
var Textbox = /** @class */ (function (_super) {
    __extends(Textbox, _super);
    function Textbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue || '',
            hasFocus: false,
            isTouched: false
        };
        _this.getValue = function () {
            return _this.state.value;
        };
        _this.hasFocus = function () {
            return _this.state.hasFocus;
        };
        _this.isTouched = function () {
            return _this.state.isTouched;
        };
        _this.handleChange = function (event) {
            // There are several React bugs in IE,
            // where the `input`'s `onChange` event is
            // fired even when the value didn't change.
            // https://github.com/facebook/react/issues/2185
            // https://github.com/facebook/react/issues/3377
            if (event.target.value !== _this.state.value) {
                _this.setState({
                    value: event.target.value,
                    isTouched: true
                }, function () {
                    var _a;
                    if (_this.props.onChange) {
                        _this.props.onChange((_a = _this.state) === null || _a === void 0 ? void 0 : _a.value);
                    }
                });
            }
        };
        _this.blur = function () {
            if (_this._input) {
                _this._input.blur();
            }
        };
        _this.handleBlur = function () {
            _this.setState({
                hasFocus: false,
                isTouched: true
            }, function () {
                if (_this.props.onBlur) {
                    _this.props.onBlur();
                }
            });
        };
        _this.handleFocus = function () {
            _this.setState({
                hasFocus: true
            }, function () {
                if (_this.props.onFocus) {
                    _this.props.onFocus();
                }
            });
        };
        _this.onInputMounted = function (input) {
            _this._input = input;
            if (!input) {
                return;
            }
            if (_this.props.autoFocus) {
                input.focus();
            }
            if (_this.props.autoFocus === 'selectAll') {
                try {
                    input.setSelectionRange(0, input.value.length);
                }
                catch (ex) {
                    // ignore
                }
            }
        };
        _this.handleKeyUp = function (event) {
            if (_this.props.onKeyUp) {
                _this.props.onKeyUp(event);
            }
        };
        _this.handleClick = function (event) {
            if (_this.props.onClick) {
                _this.props.onClick(event);
            }
        };
        return _this;
    }
    Textbox.prototype.componentWillMount = function () {
        if (this.props.value !== undefined && this.props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            warning_1.default(false, 'Input elements must be either controlled or uncontrolled ' +
                '(specify either the value prop, or the defaultValue prop, but not ' +
                'both). Decide between using a controlled or uncontrolled input ' +
                'element and remove one of these props. More info: ' +
                'https://fb.me/react-controlled-components');
            didWarnValueDefaultValue = true;
        }
    };
    Textbox.prototype.componentWillReceiveProps = function (nextProps) {
        var value = nextProps.value !== undefined ? nextProps.value : this.state.value || '';
        if (this.state.value !== value) {
            this.setState({
                value: value
            });
        }
    };
    Textbox.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, disabled = _b.disabled, readOnly = _b.readOnly, required = _b.required, placeholder = _b.placeholder, title = _b.title, minLength = _b.minLength, maxLength = _b.maxLength, type = _b.type, name = _b.name, autoComplete = _b.autoComplete;
        var _c = this.state, isTouched = _c.isTouched, value = _c.value;
        var textBoxClasses = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('textbox')] = true,
            _a[vdl_prefix_1.vdlPrefix('textbox--disabled')] = disabled,
            _a[vdl_prefix_1.vdlPrefix('textbox--readonly')] = readOnly,
            _a[vdl_prefix_1.vdlPrefix('textbox--required')] = required,
            _a[vdl_prefix_1.vdlPrefix('textbox--touched')] = isTouched,
            _a);
        var customProps = _1.omit(this.props, Object.keys(Textbox.propTypes));
        return (React.createElement("input", __assign({}, customProps, { className: classnames_1.classNames(className, textBoxClasses), ref: this.onInputMounted, type: type, name: name, value: value, disabled: disabled, onChange: this.handleChange, readOnly: readOnly, minLength: minLength, maxLength: maxLength, title: title || placeholder, autoComplete: autoComplete, onFocus: this.handleFocus, onKeyUp: this.handleKeyUp, onBlur: this.handleBlur, placeholder: placeholder, onClick: this.handleClick })));
    };
    Textbox.propTypes = {
        type: PropTypes.string,
        value: PropTypes.string,
        defaultValue: PropTypes.string,
        onChange: PropTypes.func,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        title: PropTypes.string,
        autoFocus: PropTypes.oneOf([true, false, 'selectAll']),
        placeholder: PropTypes.string,
        minLength: PropTypes.number,
        maxLength: PropTypes.number,
        onBlur: PropTypes.func,
        onFocus: PropTypes.func,
        onKeyUp: PropTypes.func,
        required: PropTypes.bool,
        className: PropTypes.string,
    };
    Textbox.defaultProps = {
        'type': 'text',
        autoFocus: false
    };
    return Textbox;
}(React.Component));
exports.Textbox = Textbox;
